import { render, staticRenderFns } from "./ComplianceSettlementModal.vue?vue&type=template&id=51a0d592&scoped=true"
import script from "./ComplianceSettlementModal.vue?vue&type=script&lang=js"
export * from "./ComplianceSettlementModal.vue?vue&type=script&lang=js"
import style0 from "./ComplianceSettlementModal.vue?vue&type=style&index=0&id=51a0d592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0d592",
  null
  
)

export default component.exports